import "./style/PrefOption.scss";

interface IPrefOptionProps {
  label: string;
  name: string;
  value: string;
  isChecked: boolean;
  handleCheckbox: (arg: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PrefOption = (
  { label, name, value, isChecked, handleCheckbox }: IPrefOptionProps
) => {
  return (
    <div className="PrefOption">
      <label className="PrefOption-Label" htmlFor={name}>
        {label}
        <input className="PrefOption-Input" type="checkbox" value={value} name={name} id={name} checked={isChecked} onChange={handleCheckbox} />
        <div className="PrefOption-Control"></div>
      </label>
    </div>
  );
};
